import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ComboBoxOption } from "@typings/components/comboBox";
import type { GetTaxonomicGroupsResponse } from "../list/type";
import type { TaxonomicGroup } from "@typings/entities/taxonomicGroup";

export async function searchTaxonomic(
  query?: string,
): Promise<ComboBoxOption<TaxonomicGroup>[]> {
  const params = new URLSearchParams();

  const trimmedQuery = query?.trim();

  if (trimmedQuery) {
    params.append("search", trimmedQuery);
  }

  const url = params.toString()
    ? `${apiPaths.taxonomicGroups.list}?${params.toString()}`
    : apiPaths.taxonomicGroups.list;

  const response = await apiClient.get<GetTaxonomicGroupsResponse>(url);

  return response.data.items.map((item) => ({
    label:
      item.species ||
      item.family ||
      item.genus ||
      item.order ||
      "Sem identificação",
    value: item.id,
    item,
  }));
}
